// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "./node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/background/bizmetry-background.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: cover;
  font-family: 'Arial', sans-serif;
  color: white;
}


body {
  margin: 0;
  font-family: 'Segoe UI', sans-serif;
  
  color: white;
}

.login-container-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.main-container {
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  padding: 20px;
  border-radius: 10px;
  display: inline-block;
}

.register-container {
  max-width: 700px;
  margin: 40px auto;
  padding: 30px 24px 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

md-input-container {
  width: 100%;
  color: white;
  margin-top: 0;
  margin-bottom: 0;
}

md-input-container label,
md-input-container .md-placeholder {
  color: white !important;
}

md-input-container input,
md-input-container textarea {
  color: white;
}

/* Resetear margen superior en md-dialog-content para evitar gap */
/* PERO: Excepto en diálogos con tabs */
md-dialog-content:not(.md-tabs-content):not([layout="column"]) {
  padding-top: 0 !important;
}

md-dialog-content > div:first-child {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* CRITICAL: Permitir padding en tabs content */
md-dialog.create-resource-dialog md-tab-content > md-dialog-content,
md-dialog.edit-resource-dialog md-tab-content > md-dialog-content,
md-dialog.bm-dialog-width md-tab-content > md-dialog-content,
md-dialog.profile-details-dialog md-tab-content > md-dialog-content,
md-dialog[aria-label="Profile Details"] md-tab-content > md-dialog-content {
  padding-top: 40px !important;
}

/* También permitir padding en el primer div dentro de tabs */
md-dialog.create-resource-dialog md-tab-content > md-dialog-content > div:first-child,
md-dialog.edit-resource-dialog md-tab-content > md-dialog-content > div:first-child,
md-dialog.bm-dialog-width md-tab-content > md-dialog-content > div:first-child,
md-dialog.profile-details-dialog md-tab-content > md-dialog-content > div:first-child,
md-dialog[aria-label="Profile Details"] md-tab-content > md-dialog-content > div:first-child {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

h1, h2 {
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: white;
  margin-bottom: 20px;
}


.ng-invalid.ng-dirty ~ .error-message,
.ng-invalid.ng-touched ~ .error-message {
  display: block;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
}

.half-width {
  flex: 1 1 48%;
  min-width: 200px;
}

.full-width {
  flex: 1 1 100%;
}

.error-container {
  background: rgba(255, 0, 0, 0.1);
  border-left: 4px solid #ff5252;
  color: #fff;
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 14px;
}

.terms {
  margin: 30px 0 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

md-button.full-width {
  width: 100%;
  margin-top: 10px;
}

/* 🔐 Login-specific styles */
.login-container {
  max-width: 400px;
  width: 100%;
  padding: 30px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.login-container h2 {
  color: white;
  text-align: center;
  margin-bottom: 24px;
}

.login-container md-input-container {
  width: 100%;
  margin-bottom: 16px;
}

.login-container md-button {
  width: 48%;
  margin-right: 4%;
  color: white;
}

.login-container md-button:last-child {
  margin-right: 0;
  background-color: transparent;
  border: 1px solid white;
  color: white;
}

.login-container md-button:last-child:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* 🎯 Estilo mejorado para el botón de registro */
.md-button.register-button {
  background: linear-gradient(135deg, #ff4081, #f50057);
  color: white;
  font-weight: bold;
  letter-spacing: 1px;
  padding: 12px 24px;
  border-radius: 8px;
  transition: background 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 12px rgba(255, 64, 129, 0.4);
  text-transform: uppercase;
  width: 100%;
  margin-top: 16px;
}

.md-button.register-button:hover {
  background: linear-gradient(135deg, #f50057, #c51162);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(245, 0, 87, 0.5);
}

.md-button.register-button:disabled {
  background: #ccc;
  color: #666;
  box-shadow: none;
  cursor: not-allowed;
}

/* ✅ Mejorar alineación del texto de términos */
.terms {
  margin: 20px 0 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #ddd;
}

.terms input[type="checkbox"] {
  margin-right: 8px;
}

/* ✅ Mejorar estilo del link */
.terms a {
  color: #add8ff;
  text-decoration: underline;
}

/* ✅ Ocultar "Already a member?" o darle estilo limpio si decidís dejarlo */
.already-member {
  text-align: center;
  font-size: 14px;
  margin-top: 8px;
  color: #ccc;
}

.already-member a {
  color: #add8ff;
  text-decoration: underline;
}

/* 💊 Unifica el tamaño y forma de pills tanto en md-chip como en view */
md-chip span,
.enum-pill {
  border-radius: 16px !important;
  font-weight: 500 !important;
  padding: 4px 22px 4px 14px !important;
  font-size: 1em !important;
  min-height: 32px !important;
  line-height: 1.7 !important;
  display: inline-flex !important;
  align-items: center !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}

/* --- FINAL: Fuerza layout horizontal en edición y alinea la X --- */
md-chips .md-chips,
md-chips .md-chips-wrap {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 8px;
  padding: 0 !important;
}

md-chip {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  min-height: 36px !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  margin: 0 6px 6px 0 !important;
  padding: 0 !important;
}

/* -- CHIP CONTENT + REMOVE ICON FINAL OVERRIDE -- */
md-chip .md-chip-content {
  box-shadow: none !important;
  border-radius: 16px !important;
  padding-right: 8px !important;  /* Aire general, pero ahora más chico */
  padding-left: 0 !important;
  min-height: 36px !important;
  display: flex !important;
  align-items: center !important;
}

md-chip .md-chip-remove {
  align-self: center !important;
  margin-left: 2px !important;     /* Apenas pegada al texto */
  margin-right: 0 !important;      /* No la empuja al borde */
  padding-right: 10px !important;  /* Aire entre la X y el borde derecho */
  font-size: 1.1em !important;
  height: 22px !important;
  width: 22px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  background: transparent !important;
}

md-chip .md-chip-remove md-icon {
  margin: 0 auto !important;
  display: block !important;
  height: 18px !important;
  width: 18px !important;
}

/* --- DESHABILITAR INTERACCIÓN EN X y INPUT DE MD-CHIPS SI ESTÁ DISABLED --- */
md-chips[ng-disabled="true"] .md-chip-remove,
md-chips[disabled] .md-chip-remove {
  pointer-events: none !important;
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* 🔒 BLOQUEA EL INPUT DE AGREGAR NUEVOS ENUMS SIN OCULTARLO */
md-chips[ng-disabled="true"] .md-chips-input,
md-chips[disabled] .md-chips-input {
  pointer-events: none !important;
  opacity: 0.4 !important;
  background: #f3f3f3 !important;
  color: #bbb !important;
  cursor: not-allowed !important;
}

/* Fallback: bloquea todos los inputs internos si alguna variante se escapa */
md-chips[ng-disabled="true"] input,
md-chips[disabled] input {
  pointer-events: none !important;
  background: #f3f3f3 !important;
  color: #bbb !important;
  cursor: not-allowed !important;
}

/* 🔒 BLOQUEA CUALQUIER INTERACCIÓN INTERNA en md-chips cuando está disabled */
md-chips[ng-disabled="true"] *,
md-chips[disabled] * {
  pointer-events: none !important;
  user-select: none !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

/* Específicamente, los input y textarea no muestran caret ni permiten edición */
md-chips[ng-disabled="true"] input,
md-chips[disabled] input,
md-chips[ng-disabled="true"] textarea,
md-chips[disabled] textarea {
  pointer-events: none !important;
  background: #f3f3f3 !important;
  color: #bbb !important;
  cursor: not-allowed !important;
  caret-color: transparent !important;
  user-select: none !important;
}

/* Save button - verde fuerte habilitado, gris deshabilitado */
.md-button.md-primary.save-btn-enabled {
  background: linear-gradient(135deg, #43a047, #a5d6a7) !important;
  color: #fff !important;
  font-weight: bold;
  box-shadow: 0 4px 16px rgba(67, 160, 71, 0.15);
  opacity: 1 !important;
  transition: opacity 0.2s, background 0.2s;
  border: none !important;
}

.md-button.md-primary.save-btn-disabled,
.md-button.md-primary:disabled,
.md-button[disabled] {
  background: #b0bec5 !important;
  color: #ececec !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
  font-weight: normal;
  border: none !important;
}

.env-disabled {
  opacity: 0.6; /* Hace que todo el environment parezca "atenuado" */
}

.env-pill {
  display: inline-block;
  padding: 4px 10px;  /* Reducido el padding */
  border-radius: 16px; /* Bordes menos redondeados */
  font-size: 0.85em;  /* Fuente más pequeña */
  font-weight: 600;   /* Peso de fuente ligeramente más liviano */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  /* Eliminar vertical-align: middle, ya no es necesario */
}


/* Eliminar fondo negro y sombra del md-toast */
body md-toast.login-success-toast {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  border: none !important;
}

/* Contenido interno del toast */
.login-success-toast-content {
  background-color: #e8f5e9; /* verde pastel claro */
  color: #2e7d32;
  font-size: 20px;
  font-weight: 700;
  padding: 16px 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Ícono */
.login-success-toast-content .material-icons {
  margin-right: 12px;
  font-size: 24px;
  color: #2e7d32;
}
/* Animación entrada + salida */
@keyframes slideFadeInOut {
  0% {
    opacity: 0;
    transform: translateX(60px);
  }
  20% {
    opacity: 1;
    transform: translateX(0);
  }
  80% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(80px);
  }


  
}


.custom-tooltip {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  font-size: 12px;
  line-height: 1.4;
  white-space: normal;
  padding-right: 4px;
}

.custom-tooltip ul {
  margin: 4px 0 0 12px;
  padding-left: 0;
  list-style-type: disc;
}

.custom-tooltip li {
  margin-bottom: 2px;
}

/* Estilo para el botón delete account */
.md-button.md-raised.md-warn {
  display: inline-flex;          /* Asegura que el ícono y el texto se alineen horizontalmente */
  align-items: center;           /* Centra verticalmente el contenido */
  justify-content: center;       /* Alinea el contenido en el centro */
  height: 40px;
  padding: 8px 16px;             /* Ajusta el padding para más espacio */
  font-size: 14px;               /* Ajusta el tamaño de la fuente */
  font-weight: bold;             /* Enfatiza el texto */
  width: auto;                   /* El ancho se ajustará al contenido */
  min-width: 120px;              /* Evita que el botón sea muy pequeño */
  white-space: nowrap;           /* Asegura que el texto no se rompa en varias líneas */
}

/* Estilo para el ícono dentro del botón */
.md-button.md-raised.md-warn md-icon {
  margin-right: 8px;             /* Espacio entre el ícono y el texto */
}

/* Efecto hover para el botón con cambio de color */
.md-button.md-primary:hover {
  background-color: #0f8513; /* Más intenso para md-primary (verde) */
}

.md-button.md-warn:hover {
  background-color: #cf0e0b; /* Más intenso para md-warn (rojo) */
}



 /* Personalización para los botones md-primary y md-warn */
.md-button.md-primary {
  background-color: #3db041; /* Personalizar el color de fondo */
  color: white; /* Color del texto */
  font-weight: bold;
  border-radius: 4px; /* Bordes redondeados */
}

.md-button.md-primary:hover {
  background-color: #0f8513; /* Color de fondo al pasar el cursor */
}

.md-button.md-warn {
  background-color: #e36258; /* Color de fondo para advertencias */
  color: white; /* Color del texto */
  font-weight: bold;
  border-radius: 4px;
}

.md-button.md-warn:hover {
  background-color: #cf0e0b; /* Color de fondo al pasar el cursor */
}

.bm-wizard-dialog {
  max-width: 900px;
  width: 90%;
}

.md-toolbar-tools h2 {
  font-family: 'Poppins', sans-serif;  /* Usa la fuente especial que usaste antes */
  font-weight: 600;  /* Ajusta el peso de la fuente si lo necesitas */
  font-size: 24px;   /* Ajusta el tamaño de la fuente según lo necesites */
}

`, "",{"version":3,"sources":["webpack://./styles.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,iFAA4F;EAC5F,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;AACd;;;AAGA;EACE,SAAS;EACT,mCAAmC;;EAEnC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA,kEAAkE;AAClE,uCAAuC;AACvC;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;;;;;EAKE,4BAA4B;AAC9B;;AAEA,6DAA6D;AAC7D;;;;;EAKE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iDAAiD;AACjD;EACE,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,8CAA8C;EAC9C,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;;EAEE,8BAA8B;EAC9B,2BAA2B;EAC3B,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,qEAAqE;AACrE;;EAEE,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;EACtC,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B,GAAG,uCAAuC;EACvE,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B,MAAM,2BAA2B;EAC5D,0BAA0B,OAAO,0BAA0B;EAC3D,8BAA8B,GAAG,uCAAuC;EACxE,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E;;EAEE,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,8DAA8D;AAC9D;;EAEE,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,6EAA6E;AAC7E;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,8EAA8E;AAC9E;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,YAAY;AACd;;AAEA,gFAAgF;AAChF;;;;EAIE,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;EACE,gEAAgE;EAChE,sBAAsB;EACtB,iBAAiB;EACjB,8CAA8C;EAC9C,qBAAqB;EACrB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY,EAAE,oDAAoD;AACpE;;AAEA;EACE,qBAAqB;EACrB,iBAAiB,GAAG,wBAAwB;EAC5C,mBAAmB,EAAE,6BAA6B;EAClD,iBAAiB,GAAG,uBAAuB;EAC3C,gBAAgB,IAAI,2CAA2C;EAC/D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,wDAAwD;AAC1D;;;AAGA,+CAA+C;AAC/C;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB,EAAE,uBAAuB;EAClD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;;;;AAIF;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,oBAAoB,WAAW,+DAA+D;EAC9F,mBAAmB,YAAY,sCAAsC;EACrE,uBAAuB,QAAQ,qCAAqC;EACpE,YAAY;EACZ,iBAAiB,cAAc,uCAAuC;EACtE,eAAe,gBAAgB,kCAAkC;EACjE,iBAAiB,cAAc,sBAAsB;EACrD,WAAW,oBAAoB,sCAAsC;EACrE,gBAAgB,eAAe,uCAAuC;EACtE,mBAAmB,YAAY,sDAAsD;AACvF;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB,cAAc,sCAAsC;AACvE;;AAEA,mDAAmD;AACnD;EACE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;AACjE;;;;CAIC,0DAA0D;AAC3D;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,YAAY,EAAE,oBAAoB;EAClC,iBAAiB;EACjB,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;EAChE,YAAY,EAAE,oBAAoB;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kCAAkC,GAAG,4CAA4C;EACjF,gBAAgB,GAAG,gDAAgD;EACnE,eAAe,IAAI,qDAAqD;AAC1E","sourcesContent":["/* General Styles */\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  background: url(\"/assets/background/bizmetry-background.jpeg\") no-repeat center center fixed;\n  background-size: cover;\n  font-family: 'Arial', sans-serif;\n  color: white;\n}\n\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', sans-serif;\n  \n  color: white;\n}\n\n.login-container-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.main-container {\n  text-align: center;\n  background: rgba(0, 0, 0, 0.3);\n  padding: 20px;\n  border-radius: 10px;\n  display: inline-block;\n}\n\n.register-container {\n  max-width: 700px;\n  margin: 40px auto;\n  padding: 30px 24px 40px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n}\n\nmd-input-container {\n  width: 100%;\n  color: white;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\nmd-input-container label,\nmd-input-container .md-placeholder {\n  color: white !important;\n}\n\nmd-input-container input,\nmd-input-container textarea {\n  color: white;\n}\n\n/* Resetear margen superior en md-dialog-content para evitar gap */\n/* PERO: Excepto en diálogos con tabs */\nmd-dialog-content:not(.md-tabs-content):not([layout=\"column\"]) {\n  padding-top: 0 !important;\n}\n\nmd-dialog-content > div:first-child {\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n}\n\n/* CRITICAL: Permitir padding en tabs content */\nmd-dialog.create-resource-dialog md-tab-content > md-dialog-content,\nmd-dialog.edit-resource-dialog md-tab-content > md-dialog-content,\nmd-dialog.bm-dialog-width md-tab-content > md-dialog-content,\nmd-dialog.profile-details-dialog md-tab-content > md-dialog-content,\nmd-dialog[aria-label=\"Profile Details\"] md-tab-content > md-dialog-content {\n  padding-top: 40px !important;\n}\n\n/* También permitir padding en el primer div dentro de tabs */\nmd-dialog.create-resource-dialog md-tab-content > md-dialog-content > div:first-child,\nmd-dialog.edit-resource-dialog md-tab-content > md-dialog-content > div:first-child,\nmd-dialog.bm-dialog-width md-tab-content > md-dialog-content > div:first-child,\nmd-dialog.profile-details-dialog md-tab-content > md-dialog-content > div:first-child,\nmd-dialog[aria-label=\"Profile Details\"] md-tab-content > md-dialog-content > div:first-child {\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n}\n\nh1, h2 {\n  font-size: 2rem;\n  font-weight: bold;\n  text-align: center;\n  color: white;\n  margin-bottom: 20px;\n}\n\n\n.ng-invalid.ng-dirty ~ .error-message,\n.ng-invalid.ng-touched ~ .error-message {\n  display: block;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.half-width {\n  flex: 1 1 48%;\n  min-width: 200px;\n}\n\n.full-width {\n  flex: 1 1 100%;\n}\n\n.error-container {\n  background: rgba(255, 0, 0, 0.1);\n  border-left: 4px solid #ff5252;\n  color: #fff;\n  padding: 10px 15px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.terms {\n  margin: 30px 0 16px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\nmd-button.full-width {\n  width: 100%;\n  margin-top: 10px;\n}\n\n/* 🔐 Login-specific styles */\n.login-container {\n  max-width: 400px;\n  width: 100%;\n  padding: 30px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.login-container h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.login-container md-input-container {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.login-container md-button {\n  width: 48%;\n  margin-right: 4%;\n  color: white;\n}\n\n.login-container md-button:last-child {\n  margin-right: 0;\n  background-color: transparent;\n  border: 1px solid white;\n  color: white;\n}\n\n.login-container md-button:last-child:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* 🎯 Estilo mejorado para el botón de registro */\n.md-button.register-button {\n  background: linear-gradient(135deg, #ff4081, #f50057);\n  color: white;\n  font-weight: bold;\n  letter-spacing: 1px;\n  padding: 12px 24px;\n  border-radius: 8px;\n  transition: background 0.3s ease, transform 0.2s ease;\n  box-shadow: 0 4px 12px rgba(255, 64, 129, 0.4);\n  text-transform: uppercase;\n  width: 100%;\n  margin-top: 16px;\n}\n\n.md-button.register-button:hover {\n  background: linear-gradient(135deg, #f50057, #c51162);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(245, 0, 87, 0.5);\n}\n\n.md-button.register-button:disabled {\n  background: #ccc;\n  color: #666;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n/* ✅ Mejorar alineación del texto de términos */\n.terms {\n  margin: 20px 0 10px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #ddd;\n}\n\n.terms input[type=\"checkbox\"] {\n  margin-right: 8px;\n}\n\n/* ✅ Mejorar estilo del link */\n.terms a {\n  color: #add8ff;\n  text-decoration: underline;\n}\n\n/* ✅ Ocultar \"Already a member?\" o darle estilo limpio si decidís dejarlo */\n.already-member {\n  text-align: center;\n  font-size: 14px;\n  margin-top: 8px;\n  color: #ccc;\n}\n\n.already-member a {\n  color: #add8ff;\n  text-decoration: underline;\n}\n\n/* 💊 Unifica el tamaño y forma de pills tanto en md-chip como en view */\nmd-chip span,\n.enum-pill {\n  border-radius: 16px !important;\n  font-weight: 500 !important;\n  padding: 4px 22px 4px 14px !important;\n  font-size: 1em !important;\n  min-height: 32px !important;\n  line-height: 1.7 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  vertical-align: middle !important;\n  box-sizing: border-box !important;\n}\n\n/* --- FINAL: Fuerza layout horizontal en edición y alinea la X --- */\nmd-chips .md-chips,\nmd-chips .md-chips-wrap {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  gap: 8px;\n  padding: 0 !important;\n}\n\nmd-chip {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  min-height: 36px !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n  margin: 0 6px 6px 0 !important;\n  padding: 0 !important;\n}\n\n/* -- CHIP CONTENT + REMOVE ICON FINAL OVERRIDE -- */\nmd-chip .md-chip-content {\n  box-shadow: none !important;\n  border-radius: 16px !important;\n  padding-right: 8px !important;  /* Aire general, pero ahora más chico */\n  padding-left: 0 !important;\n  min-height: 36px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\nmd-chip .md-chip-remove {\n  align-self: center !important;\n  margin-left: 2px !important;     /* Apenas pegada al texto */\n  margin-right: 0 !important;      /* No la empuja al borde */\n  padding-right: 10px !important;  /* Aire entre la X y el borde derecho */\n  font-size: 1.1em !important;\n  height: 22px !important;\n  width: 22px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  vertical-align: middle !important;\n  background: transparent !important;\n}\n\nmd-chip .md-chip-remove md-icon {\n  margin: 0 auto !important;\n  display: block !important;\n  height: 18px !important;\n  width: 18px !important;\n}\n\n/* --- DESHABILITAR INTERACCIÓN EN X y INPUT DE MD-CHIPS SI ESTÁ DISABLED --- */\nmd-chips[ng-disabled=\"true\"] .md-chip-remove,\nmd-chips[disabled] .md-chip-remove {\n  pointer-events: none !important;\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n}\n\n/* 🔒 BLOQUEA EL INPUT DE AGREGAR NUEVOS ENUMS SIN OCULTARLO */\nmd-chips[ng-disabled=\"true\"] .md-chips-input,\nmd-chips[disabled] .md-chips-input {\n  pointer-events: none !important;\n  opacity: 0.4 !important;\n  background: #f3f3f3 !important;\n  color: #bbb !important;\n  cursor: not-allowed !important;\n}\n\n/* Fallback: bloquea todos los inputs internos si alguna variante se escapa */\nmd-chips[ng-disabled=\"true\"] input,\nmd-chips[disabled] input {\n  pointer-events: none !important;\n  background: #f3f3f3 !important;\n  color: #bbb !important;\n  cursor: not-allowed !important;\n}\n\n/* 🔒 BLOQUEA CUALQUIER INTERACCIÓN INTERNA en md-chips cuando está disabled */\nmd-chips[ng-disabled=\"true\"] *,\nmd-chips[disabled] * {\n  pointer-events: none !important;\n  user-select: none !important;\n  cursor: not-allowed !important;\n  opacity: 0.7;\n}\n\n/* Específicamente, los input y textarea no muestran caret ni permiten edición */\nmd-chips[ng-disabled=\"true\"] input,\nmd-chips[disabled] input,\nmd-chips[ng-disabled=\"true\"] textarea,\nmd-chips[disabled] textarea {\n  pointer-events: none !important;\n  background: #f3f3f3 !important;\n  color: #bbb !important;\n  cursor: not-allowed !important;\n  caret-color: transparent !important;\n  user-select: none !important;\n}\n\n/* Save button - verde fuerte habilitado, gris deshabilitado */\n.md-button.md-primary.save-btn-enabled {\n  background: linear-gradient(135deg, #43a047, #a5d6a7) !important;\n  color: #fff !important;\n  font-weight: bold;\n  box-shadow: 0 4px 16px rgba(67, 160, 71, 0.15);\n  opacity: 1 !important;\n  transition: opacity 0.2s, background 0.2s;\n  border: none !important;\n}\n\n.md-button.md-primary.save-btn-disabled,\n.md-button.md-primary:disabled,\n.md-button[disabled] {\n  background: #b0bec5 !important;\n  color: #ececec !important;\n  opacity: 0.6 !important;\n  cursor: not-allowed !important;\n  box-shadow: none !important;\n  font-weight: normal;\n  border: none !important;\n}\n\n.env-disabled {\n  opacity: 0.6; /* Hace que todo el environment parezca \"atenuado\" */\n}\n\n.env-pill {\n  display: inline-block;\n  padding: 4px 10px;  /* Reducido el padding */\n  border-radius: 16px; /* Bordes menos redondeados */\n  font-size: 0.85em;  /* Fuente más pequeña */\n  font-weight: 600;   /* Peso de fuente ligeramente más liviano */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  /* Eliminar vertical-align: middle, ya no es necesario */\n}\n\n\n/* Eliminar fondo negro y sombra del md-toast */\nbody md-toast.login-success-toast {\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  border: none !important;\n}\n\n/* Contenido interno del toast */\n.login-success-toast-content {\n  background-color: #e8f5e9; /* verde pastel claro */\n  color: #2e7d32;\n  font-size: 20px;\n  font-weight: 700;\n  padding: 16px 24px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Ícono */\n.login-success-toast-content .material-icons {\n  margin-right: 12px;\n  font-size: 24px;\n  color: #2e7d32;\n}\n/* Animación entrada + salida */\n@keyframes slideFadeInOut {\n  0% {\n    opacity: 0;\n    transform: translateX(60px);\n  }\n  20% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  80% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(80px);\n  }\n\n\n  \n}\n\n\n.custom-tooltip {\n  max-width: 300px;\n  max-height: 200px;\n  overflow-y: auto;\n  font-size: 12px;\n  line-height: 1.4;\n  white-space: normal;\n  padding-right: 4px;\n}\n\n.custom-tooltip ul {\n  margin: 4px 0 0 12px;\n  padding-left: 0;\n  list-style-type: disc;\n}\n\n.custom-tooltip li {\n  margin-bottom: 2px;\n}\n\n/* Estilo para el botón delete account */\n.md-button.md-raised.md-warn {\n  display: inline-flex;          /* Asegura que el ícono y el texto se alineen horizontalmente */\n  align-items: center;           /* Centra verticalmente el contenido */\n  justify-content: center;       /* Alinea el contenido en el centro */\n  height: 40px;\n  padding: 8px 16px;             /* Ajusta el padding para más espacio */\n  font-size: 14px;               /* Ajusta el tamaño de la fuente */\n  font-weight: bold;             /* Enfatiza el texto */\n  width: auto;                   /* El ancho se ajustará al contenido */\n  min-width: 120px;              /* Evita que el botón sea muy pequeño */\n  white-space: nowrap;           /* Asegura que el texto no se rompa en varias líneas */\n}\n\n/* Estilo para el ícono dentro del botón */\n.md-button.md-raised.md-warn md-icon {\n  margin-right: 8px;             /* Espacio entre el ícono y el texto */\n}\n\n/* Efecto hover para el botón con cambio de color */\n.md-button.md-primary:hover {\n  background-color: #0f8513; /* Más intenso para md-primary (verde) */\n}\n\n.md-button.md-warn:hover {\n  background-color: #cf0e0b; /* Más intenso para md-warn (rojo) */\n}\n\n\n\n /* Personalización para los botones md-primary y md-warn */\n.md-button.md-primary {\n  background-color: #3db041; /* Personalizar el color de fondo */\n  color: white; /* Color del texto */\n  font-weight: bold;\n  border-radius: 4px; /* Bordes redondeados */\n}\n\n.md-button.md-primary:hover {\n  background-color: #0f8513; /* Color de fondo al pasar el cursor */\n}\n\n.md-button.md-warn {\n  background-color: #e36258; /* Color de fondo para advertencias */\n  color: white; /* Color del texto */\n  font-weight: bold;\n  border-radius: 4px;\n}\n\n.md-button.md-warn:hover {\n  background-color: #cf0e0b; /* Color de fondo al pasar el cursor */\n}\n\n.bm-wizard-dialog {\n  max-width: 900px;\n  width: 90%;\n}\n\n.md-toolbar-tools h2 {\n  font-family: 'Poppins', sans-serif;  /* Usa la fuente especial que usaste antes */\n  font-weight: 600;  /* Ajusta el peso de la fuente si lo necesitas */\n  font-size: 24px;   /* Ajusta el tamaño de la fuente según lo necesites */\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
